import $ from 'jquery';

import widgetFactory from './widgetFactory';

var widgetName = 'header';

const SCROLL_THRESHOLD = 1;
const SCROLLED_CLASSNAME = 'is-scrolled';

const widget = widgetFactory(widgetName, {
  _create() {
    this._super(widgetName);
    this.elements.$win = $(window);

    this.elements.$searchContainer = this.getWidgetElement('searchContainer');
    this.elements.$searchInput = this.elements.$searchContainer.find('input');

    this.elements.$searchInput
      .on('blur', () => {
        this.element.removeClass('has-searchInputFocused');
      })
      .on('focus', () => {
        this.element.addClass('has-searchInputFocused');
      });

    /* desactivated for now */

    //this._onScroll = this._onScroll.bind(this);
    //
    //this.elements.$placeHolder = this._createPlaceholder();
    //
    //this.elements.$win.on('scroll', this._onScroll);
    //
    //_.delay(() => this._updateScrollState(), 200);
  },

  /**
   * @return {JQuery}
   */
  _createPlaceholder() {
    const placeholder = $('<div>').hide();
    placeholder.insertBefore(this.element);

    return placeholder;
  },

  _onScroll() {
    this._updateScrollState();
  },

  _updateScrollState() {
    const { $win } = this.elements;
    const scrollTop = $win.scrollTop();
    const isScrolled = this._isScrolled();

    if (!isScrolled && scrollTop > SCROLL_THRESHOLD) {
      this._setScrolledState(true);
      this._showPlaceholder();
    } else if (isScrolled && scrollTop <= SCROLL_THRESHOLD) {
      this._setScrolledState(false);
      this._hidePlaceholder();
    }
  },

  /**
   * @return {boolean}
   */
  _isScrolled() {
    return this.element.is(`.${SCROLLED_CLASSNAME}`);
  },

  _showPlaceholder() {
    this.elements.$placeHolder.height(this._getHeight()).show();
  },

  _hidePlaceholder() {
    this.elements.$placeHolder.hide();
  },

  /**
   * @param {boolean} state
   */
  _setScrolledState(state) {
    this.element.toggleClass(SCROLLED_CLASSNAME, state);
  },

  /**
   * @return {number}
   */
  _getHeight() {
    return this.element.height();
  },
});

export default widget;
